module.exports = __webpack_public_path__ + "img/staff.1cb0f1cd.svg";